GatorSurvey.app.directive("gsDivisionQuestion", ['surveyResponseService', GsDivisionQuestion]);
function GsDivisionQuestion(surveyResponseService) {
    return {
        restrict: 'AE',
        scope: {
            gsModel: "=ngModel",
            mode: "=?"
        },
        templateUrl: 'Assets/Scripts/App/Directives/Questions/Templates/DivisionQuestionLive.html',
        controller: ['$scope', function ($scope) {
            
            $scope.TotalUsed = 0;
            $scope.updateTotalUsed = function (divisionItem) {

                var id = getUrlParameter("t") !== "1" ? divisionItem.id : divisionItem.tempId;
                surveyResponseService.updateResponseQuestion($scope.gsModel, divisionItem.input, id);
                var total = 0;
                $scope.gsModel.divisionList.forEach(function(divisionListItem) {
                    total = total + (typeof divisionListItem.input !== "undefined" ?divisionListItem.input :0) ;
                });
                $scope.TotalUsed = total;
            };
            
            surveyResponseService.AddNewQuestion($scope.gsModel,
                function(response) {
                    for (var di = 0; di < $scope.gsModel.divisionList.length; di++) {
                        for (var da = 0; da < response.divisionAnswers.length; da++) {
                            if (response.divisionAnswers[da].id === $scope.gsModel.divisionList[di].id) {
                                $scope.gsModel.divisionList[di].input =
                                    parseInt(response.divisionAnswers[da].value);
                            }
                        }
                    }
                    var total = 0;
                    $scope.gsModel.divisionList.forEach(function (divisionListItem) {
                        total = total + (typeof divisionListItem.input !== "undefined" ? divisionListItem.input : 0);
                    });
                    $scope.TotalUsed = total;
                });
        }]
    };
}